import React, { ChangeEvent } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as Loader } from '../../../../../../resources/images/Rolling.svg';

type IProps = {
  isShowModalProductDeveloppement: boolean;
  closeModalProductDeveloppement: () => void;
  valueProductDeveloppement: string;
  setValueProductDeveloppement: (txt: string) => void;
  updateProductDeveloppement: () => void;
  loader: boolean;
};
export default function ModalEditProductDevelopment(props: IProps) {
  return (
    <Modal
      show={props.isShowModalProductDeveloppement}
      className='createCompanypopup large forStep5custom'
    >
      {/* smallPopup */}
      <Modal.Header>
        <div className='headerpopupCompany noStep'>
          <h2 className='title'>Product development</h2>
          <a
            className='close'
            onClick={() => props.closeModalProductDeveloppement()}
          >
            <span className='icon-close-pop'></span>
          </a>
        </div>
      </Modal.Header>
      <Modal.Body className=''>
        <div className='contentBorder row forStrategy'>
          <div className='col-12 descCompany'>
            <label htmlFor='' className='form-group col-12'>
              What are the key short-term and long-term technical milestones?
            </label>
            <div className='form-group col-12 descCompany m-0'>
              <textarea
                maxLength={2000}
                value={props.valueProductDeveloppement}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                  props.setValueProductDeveloppement(event.target.value)
                }
              />
              <span className='caractercount'>
                {0 + (props.valueProductDeveloppement?.length || 0) + ' / 2000'}
              </span>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='contentBorder row forOverview'>
        <div className='contentBorder formForEmail text-right'>
          <button
            className='btn btn-devinsider cancel'
            onClick={() => props.closeModalProductDeveloppement()}
          >
            Cancel
          </button>
          <button
            className='btn btn-devinsider px-5'
            onClick={() => props.updateProductDeveloppement()}
          >
            {props.loader ? <Loader /> : 'Save'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
